class ResultsService {
  constructor(UserDataService, JPMCService) {
    // Dependencies
    this.UserDataService = UserDataService;
    this.JPMCService = JPMCService;
  }
  getSkillCount(jobSkills) {
    let count = 0;
    for (let skill of jobSkills) {
      let userSkill = this.UserDataService.getSkillById(skill.id);
      if (userSkill.value) {
        count++;
      }
    }
    return count;
  }
  calculateEducationMatch(jobEducation) {
    let allEducation = this.JPMCService.getConfig().education;
    let userIndex = allEducation.findIndex((ed) => {
      return ed.id === this.UserDataService.education.id;
    });
    let jobIndex = allEducation.findIndex((ed) => {
      return ed.id === jobEducation.minimum;
    });
    return 100 - (Math.abs(userIndex - jobIndex) * (100 / allEducation.length));
  }
  calculateInterest(jobInterests) {
    let rating = 0;
    let spread = 0;
    for (let interest of jobInterests) {
      let userInterest = this.UserDataService.getInterestById(interest.id);
      spread = Math.abs(interest.value - userInterest.value);
      if(spread>0) {
        spread = spread - 1;
      }
      rating += (10 - spread);
    }
    rating = Math.ceil((rating / jobInterests.length) * 10);
    return rating;
  }
  calculateSkill(jobSkills) {
    let rating = 0;
    let extraSkillRating = 0;
    let extraSkillCount = 0;
    // Loop through all skills
    for (let userSkill of this.UserDataService.skills) {
      // Find job skill that is matching the current skill in the loop
      let skill = jobSkills.find((jobSkill) => {
        return jobSkill.id === userSkill.id;
      });
      if (skill && userSkill.value) {
        rating += 100;
      } else if (!skill && userSkill.value) {
        extraSkillCount++;
        extraSkillRating += 100;
      } else {
        extraSkillCount++;
      }
    }
    rating = Math.ceil(rating / jobSkills.length);
    extraSkillRating = Math.floor((extraSkillRating / extraSkillCount) * 0.1);
    return rating - extraSkillRating;
  }
  calculateEducation(jobEducation) {
    let allEducation = this.JPMCService.getConfig().education;
    let userIndex = allEducation.findIndex((ed) => {
      return ed.id === this.UserDataService.education.id;
    });
    let jobIndex = allEducation.findIndex((ed) => {
      return ed.id === jobEducation.minimum;
    });
    if ((userIndex - jobIndex) > 1) {
      return Math.ceil((Math.abs(userIndex - jobIndex) - 1) * (100 / allEducation.length*1.5));
    } else if ((userIndex - jobIndex) < -1) {
      return Math.ceil((Math.abs(userIndex - jobIndex) - 1) * (100 / (allEducation.length*2.2)));
    } else {
      return 0;
    }
  }
  calculateOverallMatch(id) {
    let job = this.JPMCService.getJobById(id);
    if (job) {
      let interests = Math.ceil(this.calculateInterest(job.interests) * 0.6);
      let skills = Math.ceil(this.calculateSkill(job.skills) * 0.4);
      let education = this.calculateEducation(job.education);
      let overallMatch = interests + skills - education;
      if (overallMatch > 0) {
        if(overallMatch > 100) {
          return 100;
        }
        return overallMatch;
      }
    }
    return 0;
  }
}

ResultsService.$inject = ['UserDataService', 'JPMCService'];

export default ResultsService;



// WEBPACK FOOTER //
// ./src/services/results.service.js